<div class="space-y-4">
  <div class="flex items-center justify-between">
    <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide">Atributos de Variante</h3>
    @if (!showNewAttrForm) {
    <button type="button" (click)="abrirNuevoAtributo()"
      class="px-2.5 py-1 text-xs rounded-md font-medium bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1">
      <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
      </svg>
      Nuevo Atributo
    </button>
    }
  </div>

  @if (error) {
  <div class="p-3 bg-error-50 border border-error-200 rounded-lg dark:bg-error-900/20 dark:border-error-800">
    <p class="text-sm text-error-600 dark:text-error-400">{{ error }}</p>
  </div>
  }

  <!-- Formulario nuevo atributo -->
  @if (showNewAttrForm) {
  <div class="border border-brand-200 dark:border-brand-800/40 rounded-lg p-3 bg-brand-50/40 dark:bg-brand-900/10 space-y-2">
    <div class="flex items-center justify-between">
      <span class="text-xs font-semibold text-brand-600 dark:text-brand-400">Nuevo atributo</span>
      <button type="button" (click)="cerrarNuevoAtributo()" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
    <div>
      <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-0.5">Nombre del atributo <span class="text-error-500">*</span></label>
      <input type="text" [(ngModel)]="newAttrName" placeholder="Color, Talla, Material..."
        class="w-full px-2.5 py-1.5 text-xs border border-gray-200 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-800 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent" />
    </div>
    <div>
      <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-0.5">Valores iniciales (separados por coma)</label>
      <input type="text" [(ngModel)]="newAttrValues" placeholder="Rojo, Azul, Verde"
        class="w-full px-2.5 py-1.5 text-xs border border-gray-200 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-800 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent" />
    </div>
    <div class="flex items-center justify-end gap-2 pt-1">
      <button type="button" (click)="cerrarNuevoAtributo()"
        class="px-2.5 py-1 text-xs rounded-md font-medium bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600">Cancelar</button>
      <button type="button" (click)="guardarAtributo()" [disabled]="savingAttr || !newAttrName.trim()"
        class="px-2.5 py-1 text-xs rounded-md font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
        {{ savingAttr ? 'Guardando...' : 'Crear' }}
      </button>
    </div>
  </div>
  }

  @if (loading) {
  <div class="flex items-center gap-2 text-gray-500 dark:text-gray-400 py-4">
    <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"></div>
    <span class="text-sm">Cargando atributos...</span>
  </div>
  } @else if (attributes.length === 0 && !showNewAttrForm) {
  <p class="text-sm text-gray-500 dark:text-gray-400 py-4 text-center">No hay atributos de variante definidos.</p>
  } @else {
  <div class="space-y-3">
    @for (attr of attributes; track attr.id) {
    <div class="border border-gray-200 dark:border-gray-700 rounded-lg p-3">
      <div class="flex items-center justify-between mb-2">
        <span class="text-sm font-semibold text-gray-800 dark:text-white">{{ attr.name }}</span>
        <button type="button" (click)="eliminarAtributo(attr.id)"
          class="text-gray-400 hover:text-error-500 transition-colors" title="Eliminar atributo">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
          </svg>
        </button>
      </div>

      <!-- Valores como chips -->
      <div class="flex flex-wrap gap-1.5 mb-2">
        @for (val of attr.values; track val.id) {
        <div class="flex items-center gap-1 px-2 py-0.5 bg-gray-100 dark:bg-gray-700 rounded-full">
          <span class="text-xs text-gray-700 dark:text-gray-300">{{ val.value }}</span>
          <button type="button" (click)="eliminarValor(attr.id, val.id)"
            class="text-gray-400 hover:text-error-500 transition-colors ml-0.5">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        }

        <!-- Agregar valor -->
        @if (addingValueForAttrId === attr.id) {
        <div class="flex items-center gap-1">
          <input type="text" [(ngModel)]="newValueText" placeholder="Nuevo valor" (keyup.enter)="guardarValor(attr.id)"
            class="w-24 px-2 py-0.5 text-xs border border-brand-300 dark:border-brand-600 rounded-full bg-white dark:bg-gray-800 text-gray-800 dark:text-white focus:ring-1 focus:ring-brand-500" />
          <button type="button" (click)="guardarValor(attr.id)" [disabled]="savingValue || !newValueText.trim()"
            class="p-0.5 text-brand-500 hover:text-brand-700 disabled:opacity-50">
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
          </button>
          <button type="button" (click)="cerrarAgregarValor()"
            class="p-0.5 text-gray-400 hover:text-gray-600">
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        } @else {
        <button type="button" (click)="abrirAgregarValor(attr.id)"
          class="flex items-center gap-0.5 px-2 py-0.5 rounded-full border border-dashed border-gray-300 dark:border-gray-600 text-gray-400 dark:text-gray-500 hover:border-brand-400 hover:text-brand-500 transition-colors">
          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
          </svg>
          <span class="text-xs">Añadir</span>
        </button>
        }
      </div>
    </div>
    }
  </div>
  }
</div>
